import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import {
  LayoutDashboard,
  Building2,
  Users,
  MessageCircle,
  Webhook,
  ClipboardList,
  LogOut,
  ShieldCheck,
  Mail,
} from 'lucide-react';
import { Brand } from '@/components/brand/Brand';
import { useAdminAuthStore } from '@/stores/adminAuth';

const navItems = [
  { label: 'Dashboard', path: '/admin', icon: LayoutDashboard, end: true },
  { label: 'Clínicas', path: '/admin/tenants', icon: Building2 },
  { label: 'Usuários', path: '/admin/users', icon: Users },
  { label: 'Admins da plataforma', path: '/admin/platform-admins', icon: ShieldCheck },
  { label: 'WhatsApp', path: '/admin/whatsapp', icon: MessageCircle },
  { label: 'E-mails', path: '/admin/emails', icon: Mail },
  { label: 'Webhooks', path: '/admin/webhooks', icon: Webhook },
  { label: 'Auditoria', path: '/admin/audit', icon: ClipboardList },
];

export function AdminLayout() {
  const navigate = useNavigate();
  const { admin, logout } = useAdminAuthStore();

  const handleLogout = () => {
    logout();
    navigate('/admin/login', { replace: true });
  };

  return (
    <div className="flex h-screen bg-gray-50">
      {/* Sidebar */}
      <aside className="flex w-56 flex-shrink-0 flex-col border-r border-gray-200 bg-white">
        <div className="flex items-center gap-2 border-b border-gray-200 px-4 py-5">
          <Brand size="sm" subtitle="Plataforma Admin" />
        </div>

        {/* Nav */}
        <nav className="flex-1 space-y-0.5 overflow-y-auto px-2 py-3">
          {navItems.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.end}
                className={({ isActive }) =>
                  `flex items-center gap-2.5 rounded-lg px-3 py-2 text-sm transition-colors ${
                    isActive
                      ? 'bg-primary-50 text-primary-700 font-medium'
                      : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
                  }`
                }
              >
                <Icon className="h-4 w-4 flex-shrink-0" />
                {item.label}
              </NavLink>
            );
          })}
        </nav>

        {/* Admin user + logout */}
        <div className="border-t border-gray-200 px-4 py-3">
          {admin && (
            <p className="mb-2 truncate text-xs text-gray-500">{admin.name}</p>
          )}
          <button
            onClick={handleLogout}
            className="flex w-full items-center gap-2 rounded-lg px-3 py-2 text-left text-sm text-gray-600 transition-colors hover:bg-gray-100 hover:text-gray-900"
          >
            <LogOut className="h-4 w-4" />
            Sair
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 overflow-y-auto bg-gray-50">
        <Outlet />
      </main>
    </div>
  );
}
